import { AmplifyPost } from "@sunrun/sales-experience-shared/amplify-api-wrapper";
import type { ReferralSubmission } from "@sunrun/experience-ui-components";
import { logger } from "providers/logger";

type CreateReferralPayload = ReferralSubmission & {
  contactId: string;
};

const createReferral = async (
  jwt: string,
  payload: CreateReferralPayload
): Promise<unknown> => {
  return AmplifyPost(
    "Create Referral",
    "OfferExpApi",
    "/referral",
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
      body: payload,
    },
    logger
  );
};

export { createReferral };
